export default __webpack_public_path__ + "static/b8-b640c38b94b401043eb0c4ecb0ac3cb6.png";